 export class inProcessUrl {
    ASSIGN_RETURNS_URL = "ssr/v2/in-process-return/assign";
    CHANGE_DOCUMENTS_STATUS_URL = "ssr/v2/in-process-return/change-status";
    IN_PROCESS_RETURN_DELETE_URL = "ssr/v2/in-process-return/";
    IN_PROCESS_RETURNS_URL = "ssr/v2/in-process-return/all[?ClientId][&ClientName][&TaxYear][&ERO][&AssignedTo][&DocumentStatus][&Drafttatus][&EngagementType][&UploadedAfter][&PageSize][&PageNumber][&SortBy][&SortOrder]";
}

